import axios from '../plugins/axios'

export default {
  search(params){
    return axios.get('/api/v1/youtubes/search', {
      params: { tag_ids: params.tag_ids }
    })
  },
  create(params){
    return axios.post('/api/v1/youtubes/create', {
      token: params.token,
      tag_names: params.tag_names
    })
  },
}
